import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'

export interface UIBadgeDestructiveProps extends Omit<UIBadgeProps, 'variant' | 'children'> {
  children?: React.ReactNode
}

/**
 * UIBadgeDestructive - Destructive Badge Block
 * 위험 상태 표시용 배지 컴포넌트입니다.
 * 위험하거나 주의가 필요한 상태를 나타내는 배지입니다.
 */
export const UIBadgeDestructive = React.forwardRef<HTMLSpanElement, UIBadgeDestructiveProps>(
  ({ children = "Destructive", ...props }, ref) => {
    return (
      <UIBadge
        ref={ref}
        variant="destructive"
        {...props}
      >
        {children}
      </UIBadge>
    )
  }
)

UIBadgeDestructive.displayName = "UIBadgeDestructive"